import api from './client';

export const cashJurisdictionSnapshotAPI = {
  diagnostics: () => api.get('/admin/diagnostics/cash-jurisdiction-snapshot'),
  runNow: () => api.post('/admin/cash-jurisdiction-snapshot/run-now'),
  backfillPreview: (monthsBack) => api.post('/admin/cash-jurisdiction-snapshot/backfill', null, {
    params: { months_back: monthsBack, dry_run: true },
  }),
  backfillApply: (monthsBack) => api.post('/admin/cash-jurisdiction-snapshot/backfill', null, {
    params: { months_back: monthsBack, dry_run: false },
  }),
  cleanupPreview: () => api.post('/admin/cash-jurisdiction-snapshot/cleanup-fabricated-history', null, {
    params: { dry_run: true },
  }),
  cleanupApply: () => api.post('/admin/cash-jurisdiction-snapshot/cleanup-fabricated-history', null, {
    params: { dry_run: false },
  }),
  coverageDetail: (months) => api.get('/admin/diagnostics/cash-jurisdiction-snapshot/coverage-detail', {
    params: { months },
  }),
};

export const reconciliationSentinelAPI = {
  diagnostics: (eventsLimit) => api.get('/admin/diagnostics/reconciliation-sentinel', {
    params: eventsLimit ? { events_limit: eventsLimit } : undefined,
  }),
  runNow: () => api.post('/admin/reconciliation-sentinel/run-now'),
};

export const snapshotRenderTraceAPI = {
  get: ({ scope, entityId, months } = {}) => api.get('/admin/diagnostics/snapshot-render-trace', {
    params: { scope, entity_id: entityId, months },
  }),
};

export const bankAccountSnapshotAPI = {
  diagnostics: () => api.get('/admin/diagnostics/bank-account-snapshot'),
  runNow: () => api.post('/admin/bank-account-snapshot/run-now'),
  backfillPreview: (monthsBack) => api.post('/admin/bank-account-snapshot/backfill', null, {
    params: { months_back: monthsBack, dry_run: true },
  }),
  backfillApply: (monthsBack) => api.post('/admin/bank-account-snapshot/backfill', null, {
    params: { months_back: monthsBack, dry_run: false },
  }),
  cleanupPreview: () => api.post('/admin/bank-account-snapshot/cleanup-fabricated-history', null, {
    params: { dry_run: true },
  }),
  cleanupApply: () => api.post('/admin/bank-account-snapshot/cleanup-fabricated-history', null, {
    params: { dry_run: false },
  }),
};

export const monthlyOutgoingsAPI = {
  list: (params) => api.get('/monthly-outgoings', { params }),
  portfolioEntities: () => api.get('/monthly-outgoings/portfolio-entities'),
  ignore: (transactionId, data) => api.post(`/monthly-outgoings/ignore/${transactionId}`, data ?? {}),
  addOneOff: (data) => api.post('/monthly-outgoings/one-off-cost', data),
};
